import React,{Component} from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from "react-redux"
import { bindActionCreators } from "redux";

import * as profileActions from "../../actions/profileActions";
import * as profileHelpers from "../../helpers/profileHelpers"

import Companies from './Companies'
import Company from './Company'
import Reports from "./Reports";
import Report from "./Report";

class Admin extends  Component{
    render(){
        let {profile} = this.props;

        if(!profileHelpers.isAdmin(profile)){
            return null
        }

        return(
            <Switch>
                <Route path="/admin/companies" component={Companies} />
                <Route path="/admin/company/:id" component={Company} />
                <Route path="/admin/reports" component={Reports} />
                <Route path="/admin/report/:id" component={Report} />
            </Switch>
        )
    }
}


function mapStateToProps(state) {
    return {
        profile: state.profile
    }
}


// function mapDispatchToProps(dispath) {
//     return {
//         profileActions: bindActionCreators(profileActions, dispath),
//     }
// }

export default connect(mapStateToProps)(Admin);





// WEBPACK FOOTER //
// ./src/components/Admin/index.jsx